<div class="container mt-5 mb-5">
    <div class="filters">
        <h4>{{"Filtrar e Ordenar" | translate}}</h4>
        <div class="price">
            <h5 class="mt-3">{{"Preço" | translate}}</h5>
            <ngx-slider [(value)]="FiltroCircuito.ValorMinimo" [(highValue)]="FiltroCircuito.ValorMaximo"
                [options]="OpcoesValor" (userChangeEnd)="buscarDebounce()"></ngx-slider>
            <h6 class="mt-3">{{"Título" | translate}}</h6>
            <div class="form-inline">
              <input class="form-control" [(ngModel)]="FiltroCircuito.Titulo" type="text" placeholder="{{'Título' | translate}}" />
            </div>
            <h6 class="mt-3">{{"Código Circuito" | translate}}</h6>
            <div class="form-inline">
              <input class="form-control" [(ngModel)]="FiltroCircuito.CodigoCircuito" type="text" placeholder="{{'Código Circuito' | translate}}" />
            </div>
            <a class="d-flex w-50 text-left" [ngbPopover]="templateCidades" [placement]="'bottom'" [autoClose]="'outside'"
                triggers="manual" #c="ngbPopover" (click)="c.open()">
                <div class="filtro-botao d-flex flex-row align-items-center justify-content-start">
                    <h6 class="mt-3 mt-md-3">{{"Cidades" | translate}}</h6><i class="fas fa-chevron-down mt-md-2 mt-md-2 mx-md-2 mx-2"></i>
                </div>
            </a>
            <ng-template #templateCidades id="templateCidades">
                <div style="gap: 15px; padding: 10px;">
                   <input type="text" class="form-control" (ngModelChange)="filterItemCidades($event)"
                      [(ngModel)]="filterTextCidade" placeholder="Pesquisar Cidade"
                      style="margin-bottom: 1.5rem; min-width: 200px">
                   <span *ngIf="FiltroCircuito.Cidades.length > 0">Cidades Selecionadas:</span><br>
                   <div style="max-height: 50px; overflow-x: hidden; overflow-y: auto; margin-bottom: 1.5rem">
                      <strong class="cidade-pais" *ngFor="let entry of FiltroCircuito.Cidades; let i = index">
                         <a (click)="selecionarCidades(entry);"
                            class="me-2 text-muted">{{transformString(entry)}}</a>
                      </strong>
                   </div>
                   <select #selectListCidades [(ngModel)]="pesquisaCidade"
                      (ngModelChange)="selecionarCidades($event);" class="form-control"
                      style="max-height: 150px !important;" multiple>
                      <option *ngFor="let item of CidadesFiltro">
                         {{transformString(item)}}
                      </option>
                   </select>
                   <br>
                </div>
            </ng-template>
            <a class="d-flex w-50 text-left" [ngbPopover]="templatePaises" [placement]="['bottom']" [autoClose]="'outside'"
                triggers="manual" #p="ngbPopover" (click)="p.open()">
                <div class="filtro-botao d-flex flex-row align-items-center justify-content-start">
                    <h6 class="mt-3 mt-md-3">{{"Países" | translate}}</h6><i class="fas fa-chevron-down mt-md-2 mt-md-2 mx-md-2 mx-2"></i>
                </div>
            </a>
            <ng-template #templatePaises id="templatePaises">
                <div style="padding: 15px;">
                   <input type="text" class="form-control" (ngModelChange)="filterItemPaises($event)"
                      [(ngModel)]="filterTextPaises" placeholder="Pesquisar País"
                      style="margin-bottom: 1.5rem; min-width: 200px">
                   <span *ngIf="FiltroCircuito.Paises.length > 0">Países Selecionados:</span><br>
                   <div style="max-height: 70px; overflow-x: hidden; overflow-y: auto; margin-bottom: 1.5rem">
                      <strong class="cidade-pais" *ngFor="let entry of FiltroCircuito.Paises">
                         <a (click)="selecionarPaises(entry);"
                            class="mr-2 text-muted">{{transformString(entry)}}</a>
                      </strong>
                   </div>
                   <select #selectListPaises [(ngModel)]="pesquisaPais"
                      (ngModelChange)="selecionarPaises($event);" class="form-control"
                      style="max-height: 150px !important;" multiple>
                      <option *ngFor="let item of PaisesFiltro">
                         {{item}}
                      </option>
                   </select>
                   <br>
                </div>
            </ng-template>
            <h6 class="mt-3">{{"Barcos" | translate}}</h6>
            <div class="form-inline">
                <select class="form-select" name="inputBarcos">
                    <option value="-1">{{'Barco dos Circuitos' | translate}}</option>
                    <option *ngFor="let barco of FiltrosAdicionais.Barcos; let i = index" [value]="barco.Id">{{bagagem}}</option>
                </select>
            </div>
            <h6 class="mt-3">{{"Rios" | translate}}</h6>
            <div class="form-inline">
                <select class="form-select" name="inputRios">
                    <option value="-1">{{'Rio dos Circuitos' | translate}}</option>
                    <option *ngFor="let rio of FiltrosAdicionais.Rios; let i = index" [value]="rio.Id">{{rio}}</option>
                </select>
            </div>
        </div>

        <div class="filterButton">
            <button (click)="refazerBusca(busca)" type="button" class="btn btn-success">{{"Filtrar" | translate}}</button>
        </div>
    </div>
    <div class="resultList">
        <div class="alert alert-danger" role="alert" *ngIf="busca.Temporada == null || busca.Temporada == undefined || busca.Temporada == ''">
            {{"Revise os dados da busca e realize a rebusca!" | translate}}
        </div>

        <div *ngIf="buscando">
            <div class="row">
                <ng-container *ngFor="let integrador of buscasAtivas">
                    <div class="col col-md-3" style="vertical-align: middle; display: inline-flex">
                        <p>{{ integrador }}</p>
                        <img src="assets/img/loading1.gif" />
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- <div class='row nav-options' [hidden]="buscando || (Orcamento.Circuitos.length == 0)">
            <div class='col-4 btn-avancar' *ngIf="busca.ReservaId > 0">
                <button class="btn btn-success" [disabled]="buscando || (Orcamento.length == 0)"
                    (click)="rotaAvancar()">
                    <a>Avançar <i class="fas fa-chevron-right"></i></a>
                </button>
            </div>
        </div> -->

        <div *ngIf="!buscando">
            <div>
                <div *ngFor="let circuito of Circuitos" [ngClass]="visualiza_circuito ? 'circuito' : ''">
                  <app-circuito (abrirModalPreOrcamento)="abrirModalPreOrcamento($event, contentCircuitoPreOrcamento)" [agenciaId]="busca.AgenciaId" [circuito]="circuito" [usuario]="busca.usuario"
                    (removeuCircuito)="removerCircuito($event)"></app-circuito>
                </div>
                <p *ngIf="((Circuitos.length === 0 && !buscando))">{{"Esta busca não retornou nenhum resultado." | translate}}</p>
            </div>
        </div>
        <div class="justify-content-center col-md-12 col-lg-12 col-xxxl-12">
            <app-paginacao [paginacao]="paginacao" (alterarPagina)="buscarPagina($event)"></app-paginacao>
        </div>
    </div>
</div>

<ng-template let-modal #contentCircuitoPreOrcamento>
    <app-circuito-pre-orcamento [Circuito]="circuito" [busca]="busca" [Orcamento]="Orcamento">
    </app-circuito-pre-orcamento>
</ng-template>